import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { updateStyles } from '../../../../redux/slices/userActivity';

export default function FontFamily() {

    const { selectedUserActivity, userActivities, selectedComponent } = useSelector((state) => state.userActivity);
    const [styles, setStyles] = useState({});
    const [fontFamilySelected, setFontFamilySelected] = useState('')
    const dispatch = useDispatch()

    useEffect(() => {
        if (styles[selectedComponent.name] === undefined) return
        styles[selectedComponent.name].fontFamily ?
         setFontFamilySelected(styles[selectedComponent.name].fontFamily) : setFontFamilySelected('Inter')
    }, [selectedComponent.name,selectedComponent.text , selectedUserActivity,
       userActivities[selectedUserActivity], styles, ])

    useEffect(() => {
        if (Object.keys(userActivities[selectedUserActivity]).length > 1) {
            setStyles(userActivities[selectedUserActivity].theme_id.styles.styles);
        }
    }, [selectedUserActivity, Object.keys(userActivities[selectedUserActivity]).length, userActivities[selectedUserActivity]]);

    // console.log(userActivities[selectedUserActivity].theme_id.styles.styles.question)
    const handleChange = e => {
        const value = e.target.value
        if (Object.keys(userActivities[selectedUserActivity]).length > 1) {
            let tempStyles = { ...styles };
            tempStyles[selectedComponent.name] = {
                ...styles[selectedComponent.name],
                fontFamily: value,
            };
            setStyles(tempStyles);
            dispatch(
                updateStyles({
                    selectedActivityIdx: selectedUserActivity,
                    style: tempStyles,
                })
            );
        }
    }
    return (
        <div className="font-family-select mr-4" >
            <select value={fontFamilySelected} className='text_editor_item' onChange={handleChange}>
                {fontFamilies.map(fontFamily =>
                    <option key={fontFamily} value={fontFamily} > {fontFamily} </option>
                )}
            </select>
            <img src='/assets/icons/down-arrow.svg' className='select-icon' />
        </div>
    )
}


const fontFamilies = [
    'Inter',
    'Poppins',
    'Sans Serif',
]